import { render, staticRenderFns } from "./SmallBlogPostsSection.vue?vue&type=template&id=3e4571a3"
import script from "./SmallBlogPostsSection.vue?vue&type=script&lang=ts"
export * from "./SmallBlogPostsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports